module.exports = __webpack_public_path__ + "media/images/referral-program-small-fadaaf3121c43320bc855e9b90b150e6.jpg";